export default __webpack_public_path__ + "static/screenshot-1e278057a215173314bb5e58ef43b935.png";